var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H14.25V2.25C14.25 2.05109 14.171 1.86032 14.0303 1.71967C13.8897 1.57902 13.6989 1.5 13.5 1.5H2.25V0.75C2.25 0.551088 2.17098 0.360322 2.03033 0.21967C1.88968 0.0790178 1.69891 0 1.5 0C1.30109 0 1.11032 0.0790178 0.96967 0.21967C0.829018 0.360322 0.75 0.551088 0.75 0.75V17.25C0.75 17.4489 0.829018 17.6397 0.96967 17.7803C1.11032 17.921 1.30109 18 1.5 18C1.69891 18 1.88968 17.921 2.03033 17.7803C2.17098 17.6397 2.25 17.4489 2.25 17.25V16.5H10.5C10.6989 16.5 10.8897 16.421 11.0303 16.2803C11.171 16.1397 11.25 15.9489 11.25 15.75V12H18C18.1989 12 18.3897 11.921 18.5303 11.7803C18.671 11.6397 18.75 11.4489 18.75 11.25V6.75C18.75 6.55109 18.671 6.36032 18.5303 6.21967C18.3897 6.07902 18.1989 6 18 6ZM12.75 3V6H2.25V3H12.75ZM9.75 15H2.25V12H9.75V15ZM17.25 10.5H2.25V7.5H17.25V10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/Planning.edb9da0dd446992eea1ad7551c061a96.svg";
export { ForwardRef as ReactComponent };